"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var axios_client_service_1 = require("../../axios-client/axios-client.service");
var _decorators_1 = require("../../_decorators");
var fleet_invoicing_const_1 = require("./fleet-invoicing.const");
/**
 * FleetInvoicingService
 * @class
 */
var FleetInvoicingService = /** @class */ (function () {
    function FleetInvoicingService() {
    }
    /**
     * Create new sales order for a given contact
     * @param contractUuid {string}
     * @param data {SalesOrderExistingVehiclesRequest | SalesOrderNewVehiclesRequest}
     * @param hasNewVehicles {boolean}
     * @returns {Promise<any>}
     */
    FleetInvoicingService.prototype.postSalesOrder = function (contractUuid, data, hasNewVehicles) {
        if (hasNewVehicles === void 0) { hasNewVehicles = false; }
        var endpoint = hasNewVehicles
            ? fleet_invoicing_const_1.SALES_ORDERS_ENDPOINT.postSalesOrderNewVehicles
            : fleet_invoicing_const_1.SALES_ORDERS_ENDPOINT.postSalesOrderExistingVehicles;
        var url = endpoint.replace('{{contractUuid}}', contractUuid);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Get sales order given a contract and sales order uuids
     * @param contractUuid {string}
     * @param salesOrderUuid {string}
     * @returns {Promise<SalesOrderResponse>}
     */
    FleetInvoicingService.prototype.getSalesOrder = function (contractUuid, salesOrderUuid) {
        var endpoint = fleet_invoicing_const_1.SALES_ORDERS_ENDPOINT.getSalesOrder;
        var url = endpoint
            .replace('{{contractUuid}}', contractUuid)
            .replace('{{salesOrderUuid}}', salesOrderUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Create new contact
     * @param data {ContractRequest}
     * @returns {Promise<ContractResponse>}
     */
    FleetInvoicingService.prototype.postContract = function (data) {
        var url = fleet_invoicing_const_1.CONTRACTS_ENDPOINT.postContract;
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Adds a file to the contract
     * @param contractUuid: string,
     * @param  base64File: string,
     * @returns {Promise<ContractFileResponse>}
     */
    FleetInvoicingService.prototype.postContractFile = function (contractUuid, base64File) {
        var url = fleet_invoicing_const_1.CONTRACTS_ENDPOINT.postContractFile
            .replace('{{contractUuid}}', contractUuid);
        return axios_client_service_1.axiosClientInstance.post(url, { attachment: base64File });
    };
    /**
     * Create new service fee for a given contract
     * @param contractUuid {string}
     * @param data {ServiceFeeRequest}
     * @returns {Promise<any>}
     */
    FleetInvoicingService.prototype.postContractServiceFee = function (contractUuid, data) {
        var url = fleet_invoicing_const_1.SERVICE_FEES_ENDPOINT.postForContract
            .replace('{{contractUuid}}', contractUuid);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Edit a given service fee for a given contract
     * @param contractUuid {string}
     * @param serviceFeeUuid {string}
     * @param data {ServiceFeeRequest}
     * @returns {Promise<any>}
     */
    FleetInvoicingService.prototype.putContractServiceFee = function (contractUuid, serviceFeeUuid, data) {
        var url = fleet_invoicing_const_1.SERVICE_FEES_ENDPOINT.putForContract
            .replace('{{contractUuid}}', contractUuid)
            .replace('{{serviceFeeUuid}}', serviceFeeUuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    /**
     * Create new service fee for a given sales order
     * @param contractUuid {string}
     * @param salesOrderUuid {string}
     * @param serviceFeeUuid {string}
     * @param data {ServiceFeeRequest}
     * @returns {Promise<any>}
     */
    FleetInvoicingService.prototype.postSalesOrderServiceFee = function (contractUuid, salesOrderUuid, data) {
        var url = fleet_invoicing_const_1.SERVICE_FEES_ENDPOINT.postForSalesOrder
            .replace('{{contractUuid}}', contractUuid)
            .replace('{{salesOrderUuid}}', salesOrderUuid);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Edit a given service fee for a given sales order
     * @param contractUuid {string}
     * @param salesOrderUuid {string}
     * @param serviceFeeUuid {string}
     * @param data {ServiceFeeRequest}
     * @returns {Promise<any>}
     */
    FleetInvoicingService.prototype.putSalesOrderServiceFee = function (contractUuid, salesOrderUuid, serviceFeeUuid, data) {
        var url = fleet_invoicing_const_1.SERVICE_FEES_ENDPOINT.putSalesOrderServiceFee
            .replace('{{contractUuid}}', contractUuid)
            .replace('{{salesOrderUuid}}', salesOrderUuid)
            .replace('{{serviceFeeUuid}}', serviceFeeUuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    /**
     * Create new invoice plan for a given contract
     * @param data {InvoicePlanRequest}
     * @returns {Promise<InvoicePlanResponse>}
     */
    FleetInvoicingService.prototype.postInvoicePlan = function (data) {
        var url = fleet_invoicing_const_1.INVOICE_PLANS_ENDPOINT.postInvoicePlan;
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Edit a given invoice plan for a given contract
     * @param invoicePlanUuid {string}
     * @param data {InvoicePlanRequest}
     * @returns {Promise<InvoicePlanResponse>}
     */
    FleetInvoicingService.prototype.putInvoicePlan = function (invoicePlanUuid, data) {
        var url = fleet_invoicing_const_1.INVOICE_PLANS_ENDPOINT.putInvoicePlan.replace('{{invoicePlanUuid}}', invoicePlanUuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    tslib_1.__decorate([
        _decorators_1.snakeCaseRequest,
        _decorators_1.camelCaseResponse,
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", Promise)
    ], FleetInvoicingService.prototype, "postInvoicePlan", null);
    tslib_1.__decorate([
        _decorators_1.snakeCaseRequest,
        _decorators_1.camelCaseResponse,
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [String, Object]),
        tslib_1.__metadata("design:returntype", Promise)
    ], FleetInvoicingService.prototype, "putInvoicePlan", null);
    return FleetInvoicingService;
}());
/**
 * FleetInvoicingService Class Instance
 * @namespace
 */
exports.fleetInvoicing = new FleetInvoicingService();
